<template>
    <div class="reportList-wrap">

      <Modal
        class="reportList "
        width="1200"
        :closable="false"
        footer-hide
        :mask-closable="false"
        v-model="parameter">
        <div slot="header">
          <p class="header-title">报告查看</p>
        </div>

         <Row>
            <Col span="6">
              <ul class="report-list-ul">

                <li class="report-list-li" v-for="(item,index) in reportList" :key="index" @click="chengeReport(index)">
                  <p class="report-title-p">
                    <span :class="'report-type '+(item.examType==1 ? 'flag1' : 'flag2')">{{item.examType == 1 ? '检查' : '检验'}}</span>
                    <span class="report-title">{{item.report_name}}</span>
                  </p>
                  <p>
                    <span>姓名</span>
                    <span>{{item.patient_name}}</span>
                  </p>
                  <p>
                    <span>申请科室</span>
                    <span>{{item.department_name}}</span>
                  </p>
                  <p>
                    <span>申请时间</span>
                    <span>{{item.time}}</span>
                  </p>
                </li>
              </ul>
            </Col>
            <Col span="18">
            <!-- 检查报告 -->
             <div class="report-right" v-if="present.examType == 1">
               <p class="report-name-present">{{present.report_name}}</p>
                <!-- report_code -->

                <!-- report_code==00 -->
                <div class="check-data" v-if="checkData.report_code === '00'">
                    <p>
                      <span class="title-report-code">报告类别</span>
                      <span class="des-report-code">{{checkData.report_type}}</span>
                    </p>

                    <p>
                      <span class="title-report-code">检查类别</span>
                      <span class="des-report-code">{{checkData.exam_type}}</span>
                    </p>

                    <p>
                      <span class="title-report-code">检查子类</span>
                      <span class="des-report-code">{{checkData.exam_sub_type}}</span>
                    </p>

                    <p>
                      <span class="title-report-code">影像</span>
                      <span class="des-report-code">{{checkData.medical_desc}}</span>
                    </p>

                     <p>
                      <span class="title-report-code">检查结果</span>
                      <span class="des-report-code">{{checkData.diagnosis}}</span>
                    </p>

                </div>

                <!-- report_code==01 -->

                <div class="check-data"  v-if="checkData.report_code === '01'">

                    <p>
                      <span class="title-report-code">检查名称</span>
                      <span class="des-report-code">{{checkData.exam_name}}</span>
                    </p>

                    <p>
                      <span class="title-report-code">检查方法</span>
                      <span class="des-report-code">{{checkData.exam_method}}</span>
                    </p>

                    <p>
                      <span class="title-report-code">影像表现</span>
                      <span class="des-report-code">{{checkData.medical_desc}}</span>
                    </p>

                    <p>
                      <span class="title-report-code">影像</span>
                      <span class="des-report-code">{{checkData.diagnosis}}</span>
                    </p>

                </div>

                <!-- report_code==02 //超声 from pacs -->

                <div class="check-data"  v-if="checkData.report_code === '02'">
                    <p>
                      <span class="title-report-code">检查部位</span>
                      <span class="des-report-code">{{checkData.ultrasound_body_part}}</span>
                    </p>

                    <p>
                      <span class="title-report-code">超声所见</span>
                      <span class="des-report-code">{{checkData.medical_desc}}</span>
                    </p>

                    <p>
                      <span class="title-report-code">超声诊断</span>
                      <span class="des-report-code">{{checkData.diagnosis}}</span>
                    </p>

                </div>

                <!-- report_code==03 //内镜 from pacs -->

                <div class="check-data"  v-if="checkData.report_code === '03'">

                    <p>
                      <span class="title-report-code">病人主诉</span>
                      <span class="des-report-code">{{checkData.endoscope_patient_desc}}</span>
                    </p>

                    <p>
                      <span class="title-report-code">镜检所见</span>
                      <span class="des-report-code">{{checkData.medical_desc}}</span>
                    </p>

                    <p>
                      <span class="title-report-code">活检部位</span>
                      <span class="des-report-code">{{checkData.endoscope_body_part}}</span>
                    </p>

                     <p>
                      <span class="title-report-code">病理诊断</span>
                      <span class="des-report-code">{{checkData.endoscope_pathology_diagnosis}}</span>
                    </p>

                     <p>
                      <span class="title-report-code">内镜诊断</span>
                      <span class="des-report-code">{{checkData.diagnosis}}</span>
                    </p>

                     <p>
                      <span class="title-report-code">建议</span>
                      <span class="des-report-code">{{checkData.endoscope_advise}}</span>
                    </p>

                </div>

                <!-- report_code==04 //病理检查 from pacs -->

                <div class="check-data"  v-if="checkData.report_code === '04'">
                    <p>
                      <span class="title-report-code">标本名称</span>
                      <span class="des-report-code">{{checkData.pathology_specimen}}</span>
                    </p>

                    <p>
                      <span class="title-report-code">临床诊断</span>
                      <span class="des-report-code">{{checkData.pathology_clinical}}</span>
                    </p>

                    <p>
                      <span class="title-report-code">大体及手术所见</span>
                      <span class="des-report-code">{{checkData.medical_desc}}</span>
                    </p>

                    <p>
                      <span class="title-report-code">病理诊断</span>
                      <span class="des-report-code">{{checkData.diagnosis}}</span>
                    </p>

                </div>

                <!-- report_code==05 //心电系统 from pacs-->

                <div class="check-data"  v-if="checkData.report_code === '05'">
                    <p>
                      <span class="title-report-code">指标描述</span>
                      <span class="des-report-code">
                        <span class="ecg-item-list"  v-for="(items,index) in checkData.ecg_item_list" :key="index">
                          {{items.ecg_item_name}} {{items.ecg_item_value}} {{items.ecg_item_unit}}

                        </span>
                      </span>
                    </p>

                     <p>
                      <span class="title-report-code">报告医师</span>
                      <span class="des-report-code">{{checkData.report_doctor}}</span>
                    </p>

                </div>
                <div class="check-data"  v-if="checkData.report_code === '99'">
                    <p>
                      <span class="title-report-code">诊断内容</span>
                      <span class="des-report-code">{{checkData.medical_desc}}</span>
                     </p>
                    <p>
                      <span class="title-report-code">诊断结果</span>
                      <span class="des-report-code">{{checkData.diagnosis}}</span>
                    </p>
                </div>

                <viewer v-if="this.checkData.pacsImage && checkData.pacsImage.length>0" class="seek-img-list" :images="checkData.pacsImage">
                  <img v-for="(item , key) in checkData.pacsImage" :src="item.url" :key="key" class="img">
                </viewer>

             </div>

             <!--检验报告 -->
              <div class="report-right" v-if="present.examType == 2">
                <Table :row-class-name="rowClassName" :columns="examReportTable" :data="examReport"></Table>
              </div>

            </Col>
         </Row>

         <div class="record-footer">
            <Button @click="handlerCancle">取消</Button>
        </div>
      </Modal>

    </div>
</template>

<script>
import { api } from '@/services'
import { mapGetters } from 'vuex'
export default {
  name: 'recordModel',
  props: {
    parameter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      present: {
      },
      // 报告列表
      reportList: [],
      checkData: {},
      // 检验报告的内容
      examReport: [],
      // 检验报告的表格
      examReportTable: [{
        title: '英文缩写',
        key: 'abbreviation'
      }, {
        title: '名称',
        key: 'name'
      }, {
        title: '结果',
        key: 'value',
        render: (h, params) => {
          return h('div', [
            h('span', params.row.value),
            h('i')
          ])
        }
      }, {
        title: '参考值',
        key: 'reference_value',
        render: (h, params) => {
          return h('div', [
            h('span', params.row.reference_value),
            h('span', params.row.unit)
          ])
        }
      }]
    }
  },

  created: function () {
  },

  methods: {
    ...mapGetters({
      headerUserRest: 'prvateConsultation/headerUserRest'
    }),
    rowClassName (row, index) {
      if (row.result_flag === 'L') {
        return 'font-warning-top'
      } else if (row.result_flag === 'H') {
        return 'font-warning-bottom'
      }
    },
    // 切换报告
    chengeReport (index) {
      this.present = this.reportList[index]

      if (this.present.examType === '1') {
        this.getJianchaReport()
      } else {
        this.getJianyanReport()
      }
    },
    // 查看报告列表
    getReportList () {
      api.getClinicPatientExams({
        data: {
          params: {
            // card_id: this.$store.state.prvateConsultation.headerUserRest.cardId,
            pageIndex: 0,
            pageSize: 100,
            orderId: this.$store.state.prvateConsultation.orderId
            // person_id: 6179
          }
        }
      })
        .then(res => {
          if (res.data && res.data.examArray && res.data.examArray.length > 0) {
            this.reportList = res.data.examArray
            this.present = res.data.examArray[0]
            console.log(this.present)
            this.$emit('reportLengthFunc', res.data.examArray.length)
            this.chengeReport(0)
          }
        })
    },
    // 查看检查报告
    getJianchaReport () {
      api.jianchaDetailQueryById({
        data: {
          params: {
            jianchaId: this.present.examId,
            patientIdFromHis: this.present.patientIdFromHis,
            report_code: this.present.report_code
          }
        }
      })
        .then(res => {
          this.checkData = res.data
          console.log(this.checkData)
        })
    },
    // 查看检验报告
    getJianyanReport () {
      api.jianyanDetailQueryById({
        data: {
          params: {
            jianyanId: this.present.examId,
            patientIdFromHis: this.present.patientIdFromHis
          }
        }
      })
        .then(res => {
          this.examReport = res.data.value_array
        })
    },
    handlerCancle () {
      this.$emit('handlermodalCancel', {
        parameter: false
      })
    }

  },
  computed: {
    orderId () {
      return this.$store.state.prvateConsultation.orderId
    }
  },
  watch: {
    orderId: function (val) {
      // console.log(val)
      if (val) {
        this.getReportList()
      }
    }
  }
}

</script>

<style>
.header-title{
  background: #72beff;
  color: #fff;
}
.reportList{
  min-height: 800px;
}
.ivu-modal{
  width: 80% !important;
}
.reportList .ivu-modal-header{
  background: #72beff;
  color: #fff;
}
.reportList .ivu-modal-body{
  padding: 0.5 !important;
}
.reportList .ivu-modal-header p{
  color: #fff !important;
}
.report-list-ul{
  height: 10rem;
  overflow: auto;
  border: 1px solid #e3e3e3;
  /* border-bottom: none; */

}
.report-list-li{
  border-bottom: 1px solid #e3e3e3;
  padding: 0.2rem;
  cursor: pointer;
  font-size: 0.33rem;
}
.report-list-li:last-child(){
  border-bottom: none;
}
.report-type{
  color: #fff;
  font-size: 0.33rem;
  background: #32C5FF;
  padding: 0.08rem 0.15rem;
  border-radius: 1rem;
}
.flag1{
  background: #F7B500;
}
.report-title{
  font-size: 0.375rem;
  text-align: center;
  margin-left: 0.7rem;
}
.report-title-p{
   margin-bottom: 0.3rem;
}

/* 检查报告 */
.report-right{
  padding: 0 0.5rem;
}
.check-data{

}
.report-name-present{
  font-size: 0.45rem;
  color: #333333;
  margin-bottom: 0.5rem;
}

.title-report-code{
  display: inline-block;
  vertical-align: top;
  font-size: 0.33rem;
  color: #8A8A8A;
}
.des-report-code{
  display: inline-block;
  vertical-align: top;
  font-size: 0.33rem;
  margin-left: 0.3rem;
  line-height: 0.6rem;
  color: #333333;
  width: 78%;
}
.ecg-item-list{
  display: block;

}

.report-right{
  position: relative;
  height: 10rem;
  overflow: auto;
}
.reportList .seek-img-list{
  /* position: absolute; */
  bottom: 0.5rem;
  width: 55%;
  overflow: auto;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/fun_right/clinicReport/index.vue